import React from "react";

import { SVG } from "../../components/svg";
import { handleEnterKeyPressOnClickHandlers } from "../../utility";

import $OptionCard from "./styles";

interface OptionCardProps {
  title?: string,
  onClick?: (e?) => void,
  dataCyString?: string
  adminOnly?: boolean
}

const OptionCard = ({ title, onClick, dataCyString, adminOnly }: OptionCardProps) => {
  const optionCardHandlers = handleEnterKeyPressOnClickHandlers((e) => onClick?.(e));
  return (
    <$OptionCard {...optionCardHandlers} data-cy={dataCyString}>
      <div className="title">
        {title}
      </div>
      <div className="admin-arrow">
        {adminOnly && (
          <div className="admin-only" data-cy={`${dataCyString}-admin-only`}>
            Admin Only
          </div>
        )}
        <div className="arrow">
          <SVG name="arrow"/>
        </div>
      </div>
    </$OptionCard>
  )
}

export default OptionCard;